import type { ReactElement } from 'react'
import { useRouter } from 'next/router'
import css from './styles.module.css'
import { AppRoutes } from '@/config/routes'
import ExternalLink from '../ExternalLink'
import { COOKIE_URL, PRIVACY_URL, TERMS_URL } from '@/config/constants'

const footerPages = [
  AppRoutes.welcome.index,
  AppRoutes.settings.index,
  AppRoutes.imprint,
  AppRoutes.privacy,
  AppRoutes.cookie,
  AppRoutes.terms,
  AppRoutes.licenses,
]

const Footer = (): ReactElement | null => {
  const router = useRouter()

  if (!footerPages.some((path) => router.pathname.startsWith(path))) {
    return null
  }

  return (
    <footer className={css.container}>
      <ul>
        <li>
          <ExternalLink href={TERMS_URL}>Terms</ExternalLink>
        </li>

        <li>
          <ExternalLink href={PRIVACY_URL}>Privacy</ExternalLink>
        </li>

        <li>
          <ExternalLink href={COOKIE_URL}>Cookie policy</ExternalLink>
        </li>

        <li>
          Deployed by <ExternalLink href="https://www.palmeradao.xyz">Palmera</ExternalLink>
        </li>
      </ul>
    </footer>
  )
}

export default Footer
